import { Action } from '@ngrx/store';
import { RideCondition } from 'src/app/models/ride-condition';
import { RideConditionTileCache } from 'src/app/models/ride-condition-cache';

export const RideConditionAction = {
    setActiveRideCondition: '[ride condition] set active ride condition',
    setRideConditionCache: '[ride condition] set ride condition cache',
    setRideConditionsInView: '[ride condition] set ride conditions',
    updateRideConditionTileCache:
        '[ride condition] update ride condition cache',
    updateRideConditionsInView:
        '[ride condition] update ride conditions in view',
};

export class SetActiveRideCondition implements Action {
    type = RideConditionAction.setActiveRideCondition;
    constructor(public rideCondition: RideCondition | undefined) {}
}

export class SetRideConditionCache implements Action {
    type = RideConditionAction.setRideConditionCache;
    constructor(public rideConditionCaches: RideConditionTileCache[]) {}
}

export class SetRideConditionsInView implements Action {
    type = RideConditionAction.setRideConditionsInView;
    constructor(public rideConditions: RideCondition[]) {}
}

export class UpdateRideConditionsInView implements Action {
    type = RideConditionAction.updateRideConditionsInView;
    constructor(public rideConditions: RideCondition[]) {}
}

export class UpdateRideConditionTileCache implements Action {
    type = RideConditionAction.updateRideConditionTileCache;
    constructor(public tileCaches: RideConditionTileCache[]) {}
}
